import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../../api";

const ResetPassword = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;
  const otp = location.state?.otp;

  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] =
    useState("");

  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await api.post(
        "/bulk-reset-password",
        {
          email,
          otp,
          password,
          password_confirmation:
            passwordConfirmation,
        }
      );

      if (response.data.status) {

        toast.success(
          "Password reset successfully"
        );

        navigate("/login");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        "Failed to reset password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex justify-center items-center p-4">

      <div className="w-full max-w-md bg-[#17130d] border border-[#D4AF37] rounded-2xl p-6">

        <h2 className="text-2xl font-bold text-[#D4AF37] mb-6">
          Reset Password
        </h2>

        <form onSubmit={handleReset}>

          <input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e)=>setPassword(e.target.value)}
            className="w-full p-3 rounded-xl bg-black border border-[#6f5517] text-white mb-4"
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={passwordConfirmation}
            onChange={(e)=>setPasswordConfirmation(e.target.value)}
            className="w-full p-3 rounded-xl bg-black border border-[#6f5517] text-white"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full mt-4 bg-[#D4AF37] text-black font-bold py-3 rounded-xl"
          >
            {loading ? "Updating..." : "Update Password"}
          </button>

        </form>

      </div>

    </div>
  );
};

export default ResetPassword;